export default "__VITE_ASSET__42ed663e__"